import { RefObject, useEffect } from 'react';

type Handler = (event: TouchEvent) => void;

const useOnClickOutside = <T extends HTMLElement = HTMLElement>(
  ref: RefObject<T>,
  callback: Handler,
): void => {
  const handleClick = (e: TouchEvent) => {
    if (ref.current && !ref.current.contains(e.target as Node)) {
      callback(e);
    }
  };
  useEffect(() => {
    document.addEventListener('touchend', handleClick);
    return () => {
      document.removeEventListener('touchend', handleClick);
    };
  });
};

export default useOnClickOutside;
